import { CustomReportTypes } from '../../../shared/customReports/constants';

export default (customReportQueryToEdit = null) => {
  const fields = {
    name: {
      value: customReportQueryToEdit && customReportQueryToEdit.reportSetName
        ? customReportQueryToEdit.reportSetName
        : '',
      isValid: !!customReportQueryToEdit,
    },
    query: {
      value: customReportQueryToEdit && customReportQueryToEdit.sql
        ? customReportQueryToEdit.sql
        : '',
      isValid: !!customReportQueryToEdit,
    },
    serverSide: {
      value: customReportQueryToEdit && customReportQueryToEdit.serverSide
        ? customReportQueryToEdit.serverSide
        : false,
      isValid: !!customReportQueryToEdit,
    },
    defaultOrderBy: {
      value: customReportQueryToEdit && customReportQueryToEdit.defaultOrderBy
        ? customReportQueryToEdit.defaultOrderBy
        : '',
      isValid: !!customReportQueryToEdit,
    },
    display: {
      value: customReportQueryToEdit && customReportQueryToEdit.customReportFlag
        ? customReportQueryToEdit.customReportFlag
        : false,
      isValid: true,
    },
    id: {
      value: customReportQueryToEdit && customReportQueryToEdit.reportSetId
        ? customReportQueryToEdit.reportSetId
        : null,
      isValid: true,
    },
    customReportType: {
      value: CustomReportTypes.REPORT,
      isValid: true,
    },
  };

  const paramsFormData = customReportQueryToEdit && customReportQueryToEdit.params
    ? customReportQueryToEdit.params
    : {};

  const queryParams = Object.keys(paramsFormData).reduce((result, param) => {
    result[param] = '';
    return result;
  }, {});

  return {
    formData: {
      ...fields,
    },
    paramsFormData,
    queryParams,
    isFormValid: !!customReportQueryToEdit,
    triedToSubmitForm: false,
    elementsToValidate: [],
    shouldResetValues: false,
    testCustomReportQueryFormData: {},
  };
};
